module.exports = __webpack_public_path__ + "img/braunetonne.a607b9c0.svg";